import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import SelectStateModal from "../../../TreatmentPage/modals/state-modal/SelectStateModal";
import ContactPanelForEditPopups from "../../../TreatmentPage/components/ContactPanelForEditPopups";
import { formatPhoneNumber } from "../../../../Utils/helper";

import { registerCapitalized } from "./WitnessContactFields";

const WitnessEmployerFields = ({ statesAbrs }) => {
  const { register, watch, setValue } = useFormContext();

  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const handleStateShow = () => setShowStateDropdown((s) => !s);

  const workState = watch("work_state");

  return (
    <Row className="mx-0 p-l-5 p-r-5 m-t-5">
      <ContactPanelForEditPopups
        pageName="Witnesses"
        name={watch("witness_employer")}
        panel_name={"Employer"}
        phone_number={watch("work_phone")}
        email={watch("work_email")}
        address1={watch("work_address1")}
        address2={watch("work_address2")}
        city={watch("work_city")}
        state={watch("work_state")}
        zip_code={watch("work_zip")}
        ext={watch("work_extension")}
        websiteURL={watch("work_website")}
        fax_number={watch("work_fax")}
        buttonData={[]}
      />

      <Col md="auto" className="p-0 d-flex-1">
        <Row className="align-items-center custom-margin-bottom mx-0">
          <Col md={12} className="p-0">
            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Employer Name"
                  className="form-control height-25 rounded-0"
                  {...registerCapitalized(register, setValue, "witness_employer")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-r-5">
                <input
                  type="text"
                  placeholder="Address 1"
                  className="form-control height-25 rounded-0"
                  {...registerCapitalized(register, setValue, "work_address1")}
                />
              </div>
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Address 2"
                  className="form-control height-25 rounded-0"
                  {...registerCapitalized(register, setValue, "work_address2")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-l-0 p-r-5">
                <input
                  type="text"
                  placeholder="City"
                  className="form-control height-25 rounded-0"
                  {...registerCapitalized(register, setValue, "work_city")}
                />
              </div>
              <div
                className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider"
                style={{ maxWidth: "90px" }}
              >
                <div
                  className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleStateShow();
                    }
                  }}
                  onClick={handleStateShow}
                >
                  <span id="selectedOption">
                    {workState ? (
                      <div className="d-flex align-items-center">
                        <svg
                          style={{
                            width: "15px",
                            height: "15px",
                            fill: "var(--primary-80)",
                            color: "var(--primary-80)",
                            stroke: "var(--primary-80)",
                          }}
                          className={`icon icon-state-${workState}`}
                        >
                          <use xlinkHref={`#icon-state-${workState}`} />
                        </svg>
                        {workState}
                      </div>
                    ) : (
                      "State"
                    )}
                  </span>
                </div>
              </div>
              <div className="d-flex-1 pe-0" style={{ maxWidth: "90px" }}>
                <input
                  type="text"
                  placeholder="Zip"
                  className="form-control height-25 rounded-0"
                  {...register("work_zip")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-r-5 p-l-0">
                <input
                  type="text"
                  placeholder="(###) ###-####"
                  className="form-control height-25 rounded-0"
                  {...register("work_phone", {
                    onChange: (e) => setValue("work_phone", formatPhoneNumber(e.target.value)),
                  })}
                />
              </div>
              <div className="d-flex-1" style={{ maxWidth: "90px" }}>
                <input
                  type="text"
                  placeholder="Ext"
                  className="form-control height-25 rounded-0"
                  {...register("work_extension", {
                    onChange: (e) => {
                      const sanitized = e.target.value.replace(/[^0-9]/g, "");
                      setValue("work_extension", sanitized);
                    },
                  })}
                />
              </div>
              <div className="d-flex-1 ps-1 pe-0">
                <input
                  type="text"
                  placeholder="(###) ###-####"
                  className="form-control height-25 rounded-0"
                  {...register("work_fax", {
                    onChange: (e) => setValue("work_fax", formatPhoneNumber(e.target.value)),
                  })}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1">
                <input
                  type="email"
                  placeholder="Email"
                  className="form-control height-25 rounded-0"
                  {...register("work_email")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Website"
                  className="form-control height-25 rounded-0"
                  {...register("work_website")}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Col>

      {showStateDropdown && (
        <SelectStateModal
          show={showStateDropdown}
          handleClose={handleStateShow}
          onChange={(data) => {
            setValue("work_state", data?.StateAbr);
          }}
          statesData={statesAbrs}
        />
      )}
    </Row>
  );
};

export default WitnessEmployerFields;
